import React  from 'react'
import FormattedMessage from '../../helpers/FormattedMessage'

import Logo1 from "../../assets/images/logo-1.jpg"
import Logo2 from "../../assets/images/logo-2.jpg"
import Logo3 from "../../assets/images/logo-3.jpg"
import Logo4 from "../../assets/images/logo-4.jpg"
import Logo5 from "../../assets/images/logo-5.jpg"
import Logo6 from "../../assets/images/logo-6.jpg"
import VektoriseradImg from "../../assets/images/modal_Vektoriserad.png"
import FormatImg from "../../assets/images/modal_Format.png"
import ColorPickImg from "../../assets/images/modal_ColorPick.png"

export const logoStaticContent = (
  <div className="static-wrapper">
    <div className="big-card">
      <h3 className="title">
        <FormattedMessage id={"ModalOneOne.text.mainTitle"}/>
      </h3>
      <div className="description"><FormattedMessage id={"ModalOne.text.Onedescription"}/></div>
      <div className="flex-img-container">
        <img src={Logo1} alt="Skolans Gymnasium"/>
        <img src={Logo2} alt="Skolans Gymnasium Second"/>
        <img src={Logo3} alt="Skolans Gymnasium Three"/>
        <img src={Logo4} alt="Skolans Gymnasium Foru"/>
        <img src={Logo5} alt="Skolans Gymnasium Five"/>
        <img src={Logo6} alt="Skolans Gymnasium Six"/>
      </div>
    </div>
    <div className="cards-wrapper">
      <div className="small-card">
        <h3><FormattedMessage id={"ModalOne.blockOne.title"}/></h3>
        <p><FormattedMessage id={"ModalOne.blockOne.textOne"}/></p>
        <p><FormattedMessage id={"ModalOne.blockOne.textSecond"}/></p>
      </div>
      <div className="small-card">
        <h3><FormattedMessage id={"ModalOne.blockSecond.title"}/></h3>
        <p><FormattedMessage id={"ModalOne.blockSecond.textOne"}/></p>
        <p><FormattedMessage id={"ModalOne.blockSecond.textSecond"}/></p>
      </div>
      <div className="small-card">
        <h3><FormattedMessage id={"ModalOne.blockThree.title"}/></h3>
        <p><FormattedMessage id={"ModalOne.blockThree.textOne"}/></p>
        <p><FormattedMessage id={"ModalOne.blockThree.textSecond"}/></p>
      </div>
      <div className="small-card">
        <h3><FormattedMessage id={"ModalOne.blockFour.title"}/></h3>
        <p><FormattedMessage id={"ModalOne.blockFour.textOne"}/></p>
        <p><FormattedMessage id={"ModalOne.blockFour.textSecond"}/></p>
      </div>
    </div>
    <div className="double-card">
      <img src={VektoriseradImg} alt="Vektoriserad"/>
      <div>
        <h3 className="big-title"><FormattedMessage id={"ModalOne.blockFive.title"}/></h3>
        <p className="text-top-margin"><FormattedMessage id={"ModalOne.blockFive.text"}/></p>
      </div>
    </div>
    <div className="double-card">
      <div>
        <h3 className="big-title"><FormattedMessage id={"ModalOne.blockSix.title"}/></h3>
        <p className="text-top-margin"><FormattedMessage id={"ModalOne.blockSix.text"}/></p>
      </div>
      <img src={FormatImg} alt="FormatImg"/>
    </div>
    <div className="double-card">
      <img src={ColorPickImg} alt="ColorPickImg"/>
      <div>
        <h3 className="big-title"><FormattedMessage id={"ModalOne.blockSeven.title"}/></h3>
        <p className="text-top-margin"><FormattedMessage id={"ModalOne.blockSeven.text"}/></p>
      </div>
    </div>
  </div>
)